// extracted by mini-css-extract-plugin
module.exports = {"twitterBadge":"styles_twitterBadge__ohqeu","tweets":"styles_tweets__4Ps0u"};